import { IonContent, IonHeader, IonPage } from "@ionic/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import FeedItem from "../components/Feed/FeedItem";
import Header from "../components/layout/Header";
import { getBookmarks } from "../redux/actions/currentProfileActions";
import { Helmet } from "react-helmet-async";

const Bookmark = () => {
  const { bookmarks, data } = useSelector((state) => state.currentProfile);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getBookmarks());
  }, [data.bookmarks, dispatch]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">{/* <Header /> */}</IonHeader>
        <IonContent>
          {bookmarks ? (
            bookmarks.length > 0 ? (
              bookmarks.map((bookmark, idx) => (
                <FeedItem key={bookmark._id} post={bookmark} index={idx} />
              ))
            ) : (
              <div className="bookmark display-flex flex-direction-c align-items-c">
                <div className="view-wrapper">
                  <h2>{t("noBookmarksTitle")}</h2>
                  <p>{t("noBookmarksSubtitle")}</p>
                </div>
              </div>
            )
          ) : (
            ""
          )}
        </IonContent>
      </IonPage>
    </>
  );
};

export default Bookmark;
